import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper';

import {
    TRIAL_SETTINGS_PAGE_SET_TRIAL
} from '../../actions/pages/trialSettingsPage';


export interface ITrialSettingsPageState {
    trialId: number;
}

const initialState: ITrialSettingsPageState = {
    trialId: undefined
};

function setTrial(state: ITrialSettingsPageState, trialId: number): ITrialSettingsPageState {
    const newState: ITrialSettingsPageState = update(state, {
        trialId: {
            $set: trialId
        }
    });
    return newState;
}

const TrialSettingsPageReducer: Reducer<ITrialSettingsPageState> = (state: ITrialSettingsPageState = initialState, action) => { 
    switch (action.type) {
        case TRIAL_SETTINGS_PAGE_SET_TRIAL:
            return setTrial(state, action.trialId);
    }

    return state;
}

export default TrialSettingsPageReducer;